var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "exampleModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg create-encounter-modal mt-0 mb-0",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body p-0" }, [
              _vm.isrefreshpre
                ? _c("div", { attrs: { id: "cover-spin" } })
                : _vm._e(),
              _c("div", { staticClass: "pb-3 pr-5 pl-5 pt-3" }, [
                _c(
                  "div",
                  { staticStyle: { "max-width": "898px", margin: "0 auto" } },
                  [
                    _c("div", {}, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.getPdfUrl) +
                          " " +
                          _vm._s(_vm.getdatafromparent) +
                          "\n              "
                      ),
                      _c(
                        "ul",
                        { staticClass: "print-export new-rule-border" },
                        [
                          _c("li", [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.onPrintConsolidated()
                                  },
                                },
                              },
                              [
                                _c(
                                  "i",
                                  { staticClass: "material-icons print" },
                                  [_vm._v("print")]
                                ),
                              ]
                            ),
                          ]),
                          _vm.$route.name == "staffdashboard"
                            ? _c(
                                "li",
                                {
                                  staticStyle: {
                                    "border-right": "1px solid #eeeeee",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        "data-target": "#Sendemailp",
                                        "data-toggle": "modal",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showEmailPopup()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("email")]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("li", { staticClass: "mt-1" }, [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "10px" } },
                              [
                                _vm.printable_header
                                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Hide")))])
                                  : _vm._e(),
                                !_vm.printable_header
                                  ? _c("span", [_vm._v(_vm._s(_vm.$t("Show")))])
                                  : _vm._e(),
                                _vm._v(
                                  _vm._s(_vm.$t("Header")) +
                                    " \n                  "
                                ),
                              ]
                            ),
                            _c(
                              "label",
                              { staticClass: "container customcheck pr-1" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.printable_header,
                                      expression: "printable_header",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "printableheader",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.printable_header)
                                      ? _vm._i(_vm.printable_header, null) > -1
                                      : _vm.printable_header,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.storeprintableheader()
                                    },
                                    change: function ($event) {
                                      var $$a = _vm.printable_header,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.printable_header = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.printable_header = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.printable_header = $$c
                                      }
                                    },
                                  },
                                }),
                                _c("span", { staticClass: "checkmark" }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._m(0),
                    ]),
                    _vm.prescriptionobj ||
                    _vm.prescriptionobj != null ||
                    _vm.prescriptionobj != undefined
                      ? _c(
                          "div",
                          {
                            style: { fontFamily: this.$t("fontfam") },
                            attrs: { id: "consolidatedprintDiv" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.getsignaturepath) +
                                " " +
                                _vm._s(_vm.getDownloadUrl) +
                                "\n              "
                            ),
                            _c(
                              "HeaderWrapper",
                              { attrs: { printable: _vm.printable_header } },
                              [
                                _vm.printable_header
                                  ? _c(
                                      "table",
                                      {
                                        staticStyle: {
                                          "border-bottom": "1px solid #d4d5d7",
                                          "margin-top": "15px",
                                        },
                                        attrs: {
                                          width: "100%",
                                          cellspacing: "0",
                                          cellpadding: "0",
                                          border: "0",
                                        },
                                      },
                                      [
                                        _c("tr", [
                                          _c("td", [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "clinic-logo-hold",
                                              },
                                              [
                                                _vm.ClicnicUrllogo != "" &&
                                                _vm.printable_header
                                                  ? _c("img", {
                                                      attrs: {
                                                        src: _vm.ClicnicUrllogo,
                                                        height: "60px",
                                                        width: "Auto",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]),
                                        ]),
                                        _c(
                                          "tr",
                                          {
                                            staticStyle: {
                                              padding: "0px 40px",
                                              "background-color":
                                                "rgb(255, 255, 255)",
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass: "wrapper1",
                                                staticStyle: {
                                                  padding: "15px 30px 10px 0",
                                                },
                                                attrs: {
                                                  width: "50%",
                                                  valign: "top",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm.prescriptionobj
                                                  .businesssetup
                                                  ? _c(
                                                      "table",
                                                      {
                                                        attrs: {
                                                          width: "100%",
                                                          cellspacing: "0",
                                                          cellpadding: "0",
                                                          border: "0",
                                                        },
                                                      },
                                                      [
                                                        _c("tr", [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "500",
                                                                "line-height":
                                                                  "140%",
                                                                margin: "0",
                                                              },
                                                              attrs: {
                                                                valign: "top",
                                                                align: "left",
                                                              },
                                                            },
                                                            [
                                                              _vm
                                                                .prescriptionobj
                                                                .businesssetup &&
                                                              _vm
                                                                .prescriptionobj
                                                                .businesssetup
                                                                .name
                                                                ? _c("span", {
                                                                    staticStyle:
                                                                      {
                                                                        "font-weight":
                                                                          "500",
                                                                        "line-height":
                                                                          "140%",
                                                                        margin:
                                                                          "0",
                                                                      },
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm
                                                                            .prescriptionobj
                                                                            .businesssetup
                                                                            .name
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]),
                                                        _vm.prescriptionobj
                                                          .businesssetup
                                                          ? _c("tr", [
                                                              _vm
                                                                .prescriptionobj
                                                                .businesssetup
                                                                .location
                                                                ? _c(
                                                                    "td",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "block",
                                                                        },
                                                                      attrs: {
                                                                        valign:
                                                                          "top",
                                                                        align:
                                                                          "left",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm
                                                                        .prescriptionobj
                                                                        .businesssetup
                                                                        .location &&
                                                                      _vm
                                                                        .prescriptionobj
                                                                        .businesssetup
                                                                        .location
                                                                        .address
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  color:
                                                                                    "#333333",
                                                                                  "font-size":
                                                                                    "14px",
                                                                                  "font-weight":
                                                                                    "normal",
                                                                                  "line-height":
                                                                                    "140%",
                                                                                },
                                                                              domProps:
                                                                                {
                                                                                  innerHTML:
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .prescriptionobj
                                                                                        .businesssetup
                                                                                        .location
                                                                                        .address
                                                                                    ),
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "wrapper1",
                                                staticStyle: {
                                                  "padding-bottom": "10px",
                                                },
                                                attrs: {
                                                  width: "50%",
                                                  valign: "top",
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    attrs: {
                                                      width: "100%",
                                                      cellspacing: "0",
                                                      cellpadding: "0",
                                                      border: "0",
                                                    },
                                                  },
                                                  [
                                                    _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            display: "block",
                                                          },
                                                          attrs: {
                                                            valign: "top",
                                                            align: "right",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#212529",
                                                                "font-size":
                                                                  "14px",
                                                                "font-weight":
                                                                  "500",
                                                                "line-height":
                                                                  "140%",
                                                              },
                                                              attrs: {
                                                                align: "right",
                                                              },
                                                            },
                                                            [
                                                              _vm.Doctordetailsshow ==
                                                                true &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails
                                                                .title &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails
                                                                .first_name
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .prescriptionobj
                                                                          .staffDetails
                                                                          .title
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .prescriptionobj
                                                                            .staffDetails
                                                                            .first_name
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .prescriptionobj
                                                                            .staffDetails
                                                                            .last_name ==
                                                                            null
                                                                            ? ""
                                                                            : _vm
                                                                                .prescriptionobj
                                                                                .staffDetails
                                                                                .last_name
                                                                        )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#212529",
                                                                "font-size":
                                                                  "14px",
                                                                "font-weight":
                                                                  "500",
                                                                "line-height":
                                                                  "140%",
                                                                width: "100%",
                                                                display:
                                                                  "block",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.qualification
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#212529",
                                                                "font-size":
                                                                  "14px",
                                                                "font-weight":
                                                                  "500",
                                                                "line-height":
                                                                  "140%",
                                                              },
                                                              attrs: {
                                                                align: "right",
                                                              },
                                                            },
                                                            [
                                                              _vm.prescriptionobj &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails
                                                                .category
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .prescriptionobj
                                                                          .staffDetails
                                                                          .category
                                                                      )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color:
                                                                  "#212529",
                                                                "font-size":
                                                                  "14px",
                                                                "font-weight":
                                                                  "500",
                                                                "line-height":
                                                                  "140%",
                                                              },
                                                              attrs: {
                                                                align: "right",
                                                              },
                                                            },
                                                            [
                                                              _vm.Doctordetailsshow ==
                                                                true &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails &&
                                                              _vm
                                                                .prescriptionobj
                                                                .staffDetails
                                                                .registration_number
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .prescriptionobj
                                                                          .staffDetails
                                                                          .registration_number
                                                                      )
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          _vm.Doctordetailsshow ==
                                                            true &&
                                                          _vm.location_tephonedetails
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.location_tephonedetails
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("br"),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm.prescriptionobj
                                                            .businessappintmenturl &&
                                                          _vm.prescriptionobj
                                                            .businessappintmenturl !=
                                                            "null" &&
                                                          !_vm.IsVS
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#212529",
                                                                    "font-size":
                                                                      "14px",
                                                                    "font-weight":
                                                                      "500",
                                                                    "line-height":
                                                                      "140%",
                                                                  },
                                                                  attrs: {
                                                                    align:
                                                                      "right",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      ref: "Mini-site URL",
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "rgb(33, 37, 41)",
                                                                          "text-decoration":
                                                                            "none",
                                                                        },
                                                                      attrs: {
                                                                        target:
                                                                          "_blank",
                                                                        href:
                                                                          "https://" +
                                                                          _vm
                                                                            .prescriptionobj
                                                                            .businessappintmenturl,
                                                                        title:
                                                                          "Mini-site URL",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.prescriptionobj.businessappintmenturl.split(
                                                                            "/"
                                                                          )[0]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "table",
                              {
                                attrs: {
                                  cellspacing: "0",
                                  cellpadding: "0",
                                  width: "100%",
                                },
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("td", [
                                      _c("div", {
                                        class: _vm.printable_header
                                          ? "page-header-space"
                                          : "page-header-nospace",
                                      }),
                                    ]),
                                  ]),
                                ]),
                                _c("tbody", { staticStyle: { border: "0" } }, [
                                  _c("tr", [
                                    _c("td", [
                                      _c("div", { staticClass: "page" }, [
                                        _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              "border-bottom":
                                                "solid 1px #ccc !important",
                                            },
                                            attrs: {
                                              width: "100%",
                                              cellspacing: "0",
                                              cellpadding: "0",
                                              border: "0",
                                            },
                                          },
                                          [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "wrapper1",
                                                  staticStyle: {
                                                    border: "0 !important",
                                                  },
                                                  attrs: {
                                                    width: "70%",
                                                    valign: "top",
                                                    align: "left",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "table",
                                                    {
                                                      attrs: {
                                                        width: "100%",
                                                        cellspacing: "0",
                                                        cellpadding: "0",
                                                        border: "0",
                                                      },
                                                    },
                                                    [
                                                      _c("tr", [
                                                        _vm.prescriptionobj
                                                          .patientdetails
                                                          ? _c(
                                                              "td",
                                                              {
                                                                staticStyle: {
                                                                  padding:
                                                                    "10px 0",
                                                                  border:
                                                                    "0 !important",
                                                                },
                                                                attrs: {
                                                                  valign: "top",
                                                                  align: "left",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "block",
                                                                        float:
                                                                          "left",
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "500",
                                                                            "font-size":
                                                                              "14px",
                                                                            "line-height":
                                                                              "170%",
                                                                            width:
                                                                              "136px",
                                                                            display:
                                                                              "inline-block",
                                                                            float:
                                                                              "left",
                                                                          },
                                                                        attrs: {
                                                                          id: "label_patientname",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "Patientname"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .patientdetails &&
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .patientdetails
                                                                      .name
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                "font-weight":
                                                                                  "400",
                                                                                color:
                                                                                  "#333333",
                                                                                width:
                                                                                  "auto",
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                id: "value_patientname",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                        :\n                                        " +
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .prescriptionobj
                                                                                    .patientdetails
                                                                                    .name
                                                                                ) +
                                                                                "\n                                      "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "block",
                                                                        float:
                                                                          "left",
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "500",
                                                                            "font-size":
                                                                              "14px",
                                                                            "line-height":
                                                                              "170%",
                                                                            width:
                                                                              "136px",
                                                                            display:
                                                                              "inline-block",
                                                                            float:
                                                                              "left",
                                                                          },
                                                                        attrs: {
                                                                          id: "label_registrationno",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "RegistrationNo"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "400",
                                                                            color:
                                                                              "#333333",
                                                                            width:
                                                                              "auto",
                                                                          },
                                                                        attrs: {
                                                                          id: "value_registrationno",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                        :\n                                        " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .prescriptionobj
                                                                                .patientdetails
                                                                                .patient_RegId
                                                                            ) +
                                                                            "\n                                      "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "block",
                                                                        float:
                                                                          "left",
                                                                        width:
                                                                          "100%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "500",
                                                                            "font-size":
                                                                              "14px",
                                                                            "line-height":
                                                                              "170%",
                                                                            width:
                                                                              "136px",
                                                                            display:
                                                                              "inline-block",
                                                                            float:
                                                                              "left",
                                                                          },
                                                                        attrs: {
                                                                          id: "label_agesex",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "AgeSex"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-weight":
                                                                              "400",
                                                                            color:
                                                                              "#333333",
                                                                            width:
                                                                              "auto",
                                                                          },
                                                                        attrs: {
                                                                          id: "value_agesex",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                        :\n                                        "
                                                                        ),
                                                                        _vm.ageCalculated
                                                                          ? _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.ageCalculated
                                                                                  ) +
                                                                                    " /"
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm
                                                                          .prescriptionobj
                                                                          .patientdetails
                                                                          .gender
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "c_name",
                                                                                staticStyle:
                                                                                  {
                                                                                    "text-transform":
                                                                                      "capitalize",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                          " +
                                                                                    _vm._s(
                                                                                      _vm
                                                                                        .prescriptionobj
                                                                                        .patientdetails
                                                                                        .gender
                                                                                    ) +
                                                                                    "\n                                        "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              !_vm.IsVS
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "wrapper1",
                                                      staticStyle: {
                                                        padding:
                                                          "10px 0px 10px 0",
                                                        "border-bottom":
                                                          "1px solid #d4d5d7",
                                                      },
                                                      attrs: {
                                                        width: "30%",
                                                        valign: "top",
                                                        "text-align": "right",
                                                      },
                                                    },
                                                    [
                                                      _vm.getQRCode()
                                                        ? _c("img", {
                                                            staticStyle: {
                                                              float: "right",
                                                            },
                                                            attrs: {
                                                              src: _vm.getQRCode(),
                                                              width: "81",
                                                              height: "80",
                                                            },
                                                          })
                                                        : _c("img", {
                                                            staticClass:
                                                              "disable-holdsec",
                                                            staticStyle: {
                                                              float: "right",
                                                            },
                                                            attrs: {
                                                              src: "https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/qr-code.gif",
                                                              width: "81",
                                                              height: "80",
                                                            },
                                                          }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "table",
                                          {
                                            staticClass: "wrapper",
                                            staticStyle: {
                                              float: "left",
                                              width: "100%",
                                            },
                                            attrs: {
                                              width: "100%",
                                              border: "0",
                                              cellspacing: "0",
                                              cellpadding: "0",
                                            },
                                          },
                                          [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "wrapper",
                                                  staticStyle: {
                                                    padding: "10px 0 5px 0",
                                                  },
                                                  attrs: {
                                                    align: "left",
                                                    valign: "top",
                                                    bgcolor: "#FFFFFF",
                                                  },
                                                },
                                                [
                                                  _vm.prescriptionobj
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-text",
                                                          staticStyle: {
                                                            color: "#212529",
                                                            "font-size": "14px",
                                                            "line-height":
                                                              "140%",
                                                            "text-transform":
                                                              "capitalize",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "500",
                                                              },
                                                              attrs: {
                                                                id: "label_date",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("Date")
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                _vm
                                                                  .prescriptionobj
                                                                  .modalencounterdate
                                                              ) +
                                                              "\n                              "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("br"),
                                        _vm.show.Vitals &&
                                        _vm.vitals &&
                                        _vm.vitals.length
                                          ? _c("section", [
                                              _vm._m(1),
                                              _c(
                                                "table",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                    "font-size": "14px",
                                                    "line-height": "20px",
                                                    border:
                                                      "1px solid rgb(201, 201, 201)",
                                                  },
                                                },
                                                [
                                                  _vm.vitals &&
                                                  _vm.vitals.length
                                                    ? _c(
                                                        "tr",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                            display: "table",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "wrapper",
                                                              staticStyle: {
                                                                width: "98%",
                                                                padding:
                                                                  "10px 10px 0",
                                                                display:
                                                                  "table-cell",
                                                              },
                                                              attrs: {
                                                                align: "left",
                                                                valign: "top",
                                                                bgcolor:
                                                                  "#FFFFFF",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "table",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%",
                                                                    "table-layout":
                                                                      "fixed",
                                                                  },
                                                                  attrs: {
                                                                    border: "0",
                                                                    cellspacing:
                                                                      "0",
                                                                    cellpadding:
                                                                      "0",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.vitalRows,
                                                                  function (
                                                                    row,
                                                                    rIdx
                                                                  ) {
                                                                    return _c(
                                                                      "tr",
                                                                      {
                                                                        key: rIdx,
                                                                      },
                                                                      _vm._l(
                                                                        row,
                                                                        function (
                                                                          vital,
                                                                          cIdx
                                                                        ) {
                                                                          return _c(
                                                                            "td",
                                                                            {
                                                                              key: cIdx,
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "33.33%",
                                                                                  padding:
                                                                                    "6px 10px 6px 0",
                                                                                  "font-size":
                                                                                    "14px",
                                                                                  "word-break":
                                                                                    "break-word",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  align:
                                                                                    "left",
                                                                                  valign:
                                                                                    "top",
                                                                                },
                                                                            },
                                                                            [
                                                                              vital
                                                                                ? [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            "font-weight":
                                                                                              "600",
                                                                                            color:
                                                                                              "rgb(51,51,51)",
                                                                                          },
                                                                                        domProps:
                                                                                          {
                                                                                            innerHTML:
                                                                                              _vm._s(
                                                                                                vital.label
                                                                                              ),
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            "font-weight":
                                                                                              "400",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          ": " +
                                                                                            _vm._s(
                                                                                              vital.value
                                                                                            )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                : _vm._e(),
                                                                            ],
                                                                            2
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.show.SymptomsAndSummary &&
                                        _vm.encounter
                                          ? _c("section", [
                                              _vm._m(2),
                                              _c(
                                                "table",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                    "font-size": "14px",
                                                    "line-height": "20px",
                                                    border:
                                                      "1px solid rgb(201, 201, 201)",
                                                  },
                                                },
                                                [
                                                  _vm.symptomsText
                                                    ? _c("tr", [
                                                        _vm._m(3),
                                                        _c(
                                                          "td",
                                                          {
                                                            attrs: {
                                                              id: "value_symptoms",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.symptomsText
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.encounter.Doctor_Summary
                                                    ? _c("tr", [
                                                        _vm._m(4),
                                                        _c(
                                                          "td",
                                                          {
                                                            attrs: {
                                                              id: "value_summary",
                                                            },
                                                          },
                                                          [
                                                            _vm.encounter
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-top":
                                                                          "2px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c("div", {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm
                                                                                .encounter
                                                                                .Doctor_Summary
                                                                            ),
                                                                        },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.show.ChiefComplaints &&
                                        _vm.chiefComplaintsList &&
                                        _vm.chiefComplaintsList.length
                                          ? _c("section", [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "16px",
                                                    background: "#2959a7",
                                                    color: "#ffffff",
                                                    "font-weight": "600",
                                                    padding: "7px 10px",
                                                    "font-size": "15px",
                                                  },
                                                  attrs: {
                                                    id: "label_chiefcomplaints",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            Chief complaints\n                          "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "10px 6px",
                                                    "font-size": "14px",
                                                    "line-height": "20px",
                                                    border: "1px solid #c9c9c9",
                                                    background: "#f9f9f9",
                                                  },
                                                  attrs: {
                                                    id: "value_chiefcomplaints",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.chiefComplaintsList
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.show.ICD10 &&
                                        _vm.problemsandillnesslist &&
                                        _vm.problemsandillnesslist.length
                                          ? _c("section", [
                                              _vm._m(5),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    padding: "10px 6px",
                                                    "font-size": "14px",
                                                    border: "1px solid #c9c9c9",
                                                    background: "#f9f9f9",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "strong",
                                                    {
                                                      attrs: {
                                                        id: "label_selectedcode",
                                                      },
                                                    },
                                                    [_vm._v("Selected code:")]
                                                  ),
                                                  _vm._l(
                                                    _vm.problemsandillnesslist,
                                                    function (item, i) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: "icd-block-" + i,
                                                        },
                                                        _vm._l(
                                                          item.selected_code,
                                                          function (code, j) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  "icd-" +
                                                                  i +
                                                                  "-" +
                                                                  j,
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icd-code",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        code.code
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                                -\n                                "
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        "icd_desc_" +
                                                                        i +
                                                                        "_" +
                                                                        j,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        code.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("span", [
                                                                  _vm._v(", "),
                                                                ]),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.show.Prescription &&
                                        _vm.prescriptionobj &&
                                        _vm.prescriptionobj
                                          .modalresultPrescriptions
                                          ? _c("section", [
                                              _vm._m(6),
                                              _c(
                                                "table",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                    "border-collapse":
                                                      "collapse",
                                                    "font-size": "14px",
                                                    "margin-top": "0",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "tr",
                                                    {
                                                      staticStyle: {
                                                        background: "#eef2fb",
                                                        "font-weight": "bold",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            border:
                                                              "1px solid #c9c9c9 !important",
                                                            padding: "7px",
                                                          },
                                                          attrs: {
                                                            id: "label_medicine_name",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MedicineName"
                                                                )
                                                              ) +
                                                              "\n                              "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            border:
                                                              "1px solid #c9c9c9 !important",
                                                            padding: "7px",
                                                          },
                                                          attrs: {
                                                            id: "label_dosage",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                _vm.$t("Dosage")
                                                              ) +
                                                              "\n                              "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "td",
                                                        {
                                                          staticStyle: {
                                                            border:
                                                              "1px solid #c9c9c9 !important",
                                                            padding: "7px",
                                                          },
                                                          attrs: {
                                                            id: "label_duration",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Duration"
                                                                )
                                                              ) +
                                                              "\n                              "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._l(
                                                    _vm.prescriptionobj
                                                      .modalresultPrescriptions,
                                                    function (val, index) {
                                                      return _vm.prescriptionobj
                                                        .modalresultPrescriptions
                                                        ? _c(
                                                            "tr",
                                                            { key: index },
                                                            [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid #c9c9c9 !important",
                                                                    padding:
                                                                      "7px",
                                                                  },
                                                                },
                                                                [
                                                                  val.drug_details &&
                                                                  val
                                                                    .drug_details
                                                                    .Formulation
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "text-transform":
                                                                                "uppercase",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                val
                                                                                  .drug_details
                                                                                  .Formulation
                                                                              ) +
                                                                              " \n                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : val.medicine_type &&
                                                                      val
                                                                        .medicine_type
                                                                        .name
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "text-transform":
                                                                                "uppercase",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                val
                                                                                  .medicine_type
                                                                                  .name
                                                                              ) +
                                                                              " \n                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  val.drug_details &&
                                                                  val.drug_details.hasOwnProperty(
                                                                    "CIMSDESC"
                                                                  ) &&
                                                                  val
                                                                    .drug_details
                                                                    .CIMSDESC
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-weight":
                                                                                "500",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              id:
                                                                                "med_name_" +
                                                                                index,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                val
                                                                                  .drug_details
                                                                                  .CIMSDESC
                                                                              ) +
                                                                              "\n                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : val.drug_details &&
                                                                      !val.drug_details.hasOwnProperty(
                                                                        "CIMSDESC"
                                                                      )
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-weight":
                                                                                "500",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                val.drug_details
                                                                              ) +
                                                                              "\n                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  val.strength ||
                                                                  val.strength_units
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                val.strength
                                                                              ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                val.strength_units
                                                                              ) +
                                                                              "\n                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid #c9c9c9 !important",
                                                                    padding:
                                                                      "7px",
                                                                  },
                                                                },
                                                                [
                                                                  !val.direction_morning &&
                                                                  !val.direction_afternoon &&
                                                                  !val.direction_evening &&
                                                                  !val.direction_night &&
                                                                  val.direction_sos
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                val.tables_count
                                                                              ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "SOS"
                                                                                )
                                                                              ) +
                                                                              "\n                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        [
                                                                          val.direction_morning
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      id:
                                                                                        "med_dosage_morning_" +
                                                                                        index,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                    " +
                                                                                      _vm._s(
                                                                                        val.tables_count
                                                                                      ) +
                                                                                      " " +
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "Breakfast"
                                                                                        )
                                                                                      ) +
                                                                                      "\n                                  "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          val.direction_afternoon
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      id:
                                                                                        "med_dosage_afternoon_" +
                                                                                        index,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                    " +
                                                                                      _vm._s(
                                                                                        val.tables_count
                                                                                      ) +
                                                                                      " " +
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "Lunch"
                                                                                        )
                                                                                      ) +
                                                                                      "\n                                  "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          val.direction_evening
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      id:
                                                                                        "med_dosage_evening_" +
                                                                                        index,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                    " +
                                                                                      _vm._s(
                                                                                        val.tables_count
                                                                                      ) +
                                                                                      " " +
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "Evening"
                                                                                        )
                                                                                      ) +
                                                                                      "\n                                  "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          val.direction_night
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      id:
                                                                                        "med_dosage_night_" +
                                                                                        index,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                    " +
                                                                                      _vm._s(
                                                                                        val.tables_count
                                                                                      ) +
                                                                                      " " +
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "Dinner"
                                                                                        )
                                                                                      ) +
                                                                                      "\n                                  "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          val.direction_sos
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      id:
                                                                                        "med_dosage_sos_" +
                                                                                        index,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                    " +
                                                                                      _vm._s(
                                                                                        val.tables_count
                                                                                      ) +
                                                                                      " " +
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "SOS"
                                                                                        )
                                                                                      ) +
                                                                                      "\n                                  "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                  _c("br"),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                      attrs: {
                                                                        id:
                                                                          "med_food_" +
                                                                          index,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                  (\n                                  " +
                                                                          _vm._s(
                                                                            val.direction_preffered ==
                                                                              1
                                                                              ? _vm.$t(
                                                                                  "Afterfood"
                                                                                )
                                                                              : _vm.$t(
                                                                                  "Beforefood"
                                                                                )
                                                                          ) +
                                                                          "\n                                  )\n                                "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid #c9c9c9 !important",
                                                                    padding:
                                                                      "7px",
                                                                  },
                                                                },
                                                                [
                                                                  val.course_period
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              id:
                                                                                "med_duration_" +
                                                                                index,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                val.course_period
                                                                              ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "days"
                                                                                )
                                                                              ) +
                                                                              "\n                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c("br"),
                                                                  val.course_qty_pharmacy
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-size":
                                                                                "12px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  (" +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "Total"
                                                                                )
                                                                              ) +
                                                                              " : " +
                                                                              _vm._s(
                                                                                val.course_qty_pharmacy
                                                                              ) +
                                                                              ")\n                                "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    }
                                                  ),
                                                  !_vm.prescriptionobj
                                                    .modalresultPrescriptions
                                                    ? _c("tr", [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticStyle: {
                                                              padding: "15px",
                                                              "text-align":
                                                                "center",
                                                            },
                                                            attrs: {
                                                              colspan: "3",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Noprescriptionshavebeensuggested."
                                                                  )
                                                                ) +
                                                                "\n                              "
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.show.Investigations &&
                                        _vm.investigationobj &&
                                        Array.isArray(
                                          _vm.investigationobj
                                            .modalresultInvestigation
                                        ) &&
                                        _vm.investigationobj
                                          .modalresultInvestigation.length
                                          ? _c("section", [
                                              _vm._m(7),
                                              _vm.investigationobj
                                                .modalresultInvestigation &&
                                              _vm.investigationobj
                                                .modalresultInvestigation
                                                .length > 0
                                                ? _c(
                                                    "div",
                                                    _vm._l(
                                                      _vm.investigationobj
                                                        .modalresultInvestigation,
                                                      function (item, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticStyle: {
                                                              padding:
                                                                "10px 6px",
                                                              "font-size":
                                                                "14px",
                                                              border:
                                                                "1px solid #c9c9c9",
                                                              "border-top":
                                                                "none",
                                                              background:
                                                                "#f9f9f9",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "font-weight":
                                                                    "500",
                                                                },
                                                                attrs: {
                                                                  id:
                                                                    "investigation_name_" +
                                                                    index,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                " +
                                                                    _vm._s(
                                                                      item.investigation_name
                                                                    ) +
                                                                    "\n                              "
                                                                ),
                                                              ]
                                                            ),
                                                            item.notes
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "13px",
                                                                        "margin-top":
                                                                          "4px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        attrs: {
                                                                          id:
                                                                            "investigation_note_label_" +
                                                                            index,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Notes:"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        attrs: {
                                                                          id:
                                                                            "investigation_note_" +
                                                                            index,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.notes
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                        _vm.show.Immunization &&
                                        _vm.immunizationobj &&
                                        _vm.immunizationobj
                                          .modalresultImmunization &&
                                        _vm.immunizationobj
                                          .modalresultImmunization.length > 0
                                          ? _c("section", [
                                              _vm._m(8),
                                              _vm.immunizationobj
                                                .modalresultChiefComplaints &&
                                              _vm.immunizationobj
                                                .modalresultChiefComplaints
                                                .length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        padding: "10px",
                                                        border:
                                                          "1px solid #c9c9c9",
                                                        "border-top": "none",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            " +
                                                          _vm._s(
                                                            _vm.immunizationobj.modalresultChiefComplaints.join(
                                                              ", "
                                                            )
                                                          ) +
                                                          "\n                          "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm.immunizationobj
                                                .modalresultImmunization &&
                                              _vm.immunizationobj
                                                .modalresultImmunization
                                                .length > 0
                                                ? _c(
                                                    "table",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                        "border-collapse":
                                                          "collapse",
                                                        "font-size": "14px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          staticStyle: {
                                                            background:
                                                              "#eef2fb",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                border:
                                                                  "1px solid #c9c9c9 !important",
                                                                padding: "7px",
                                                              },
                                                              attrs: {
                                                                id: "label_vaccine_name",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "VaccineName"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                border:
                                                                  "1px solid #c9c9c9 !important",
                                                                padding: "7px",
                                                              },
                                                              attrs: {
                                                                id: "label_due_date",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Duedate"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                border:
                                                                  "1px solid #c9c9c9 !important",
                                                                padding: "7px",
                                                              },
                                                              attrs: {
                                                                id: "label_route",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Route"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                border:
                                                                  "1px solid #c9c9c9 !important",
                                                                padding: "7px",
                                                              },
                                                              attrs: {
                                                                id: "label_site",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("Site")
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                border:
                                                                  "1px solid #c9c9c9 !important",
                                                                padding: "7px",
                                                              },
                                                              attrs: {
                                                                id: "label_note",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("Note")
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._l(
                                                        _vm.immunizationobj
                                                          .modalresultImmunization,
                                                        function (val, index) {
                                                          return _c(
                                                            "tr",
                                                            {
                                                              key:
                                                                "vaccine-" +
                                                                index,
                                                            },
                                                            [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid #c9c9c9 !important",
                                                                    padding:
                                                                      "7px",
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "vaccine_name_" +
                                                                      index,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        val.selected_vaccine_name
                                                                      ) +
                                                                      "\n                              "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid #c9c9c9 !important",
                                                                    padding:
                                                                      "7px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        val.selected_duedate
                                                                      ) +
                                                                      "\n                              "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid #c9c9c9 !important",
                                                                    padding:
                                                                      "7px",
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "route_" +
                                                                      index,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        val.selected_route ||
                                                                          "N/A"
                                                                      ) +
                                                                      "\n                              "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid #c9c9c9 !important",
                                                                    padding:
                                                                      "7px",
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "site_" +
                                                                      index,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        val.site_name ||
                                                                          "N/A"
                                                                      ) +
                                                                      "\n                              "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticStyle: {
                                                                    border:
                                                                      "1px solid #c9c9c9 !important",
                                                                    padding:
                                                                      "7px",
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "note_" +
                                                                      index,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        val.notes ||
                                                                          "N/A"
                                                                      ) +
                                                                      "\n                              "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _vm._l(
                                                        _vm.immunizationobj
                                                          .modalresultImmunization,
                                                        function (val, index) {
                                                          return val.defaultschedule ||
                                                            (val.schedule &&
                                                              val.schedule
                                                                .length)
                                                            ? _c(
                                                                "tr",
                                                                {
                                                                  key:
                                                                    "schedule-" +
                                                                    index,
                                                                },
                                                                [
                                                                  _c(
                                                                    "td",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          border:
                                                                            "1px solid #c9c9c9 !important",
                                                                          padding:
                                                                            "7px",
                                                                        },
                                                                      attrs: {
                                                                        colspan:
                                                                          "5",
                                                                      },
                                                                    },
                                                                    [
                                                                      val.defaultschedule
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      type: "radio",
                                                                                      disabled:
                                                                                        "",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    val.defaultschedule
                                                                                  ) +
                                                                                  "\n                                    \n                                  " +
                                                                                  _vm._s(
                                                                                    val.vaccinedosage ||
                                                                                      _vm.$t(
                                                                                        "NA"
                                                                                      )
                                                                                  ) +
                                                                                  "\n                                    \n                                  " +
                                                                                  _vm._s(
                                                                                    val.selected_duedate
                                                                                  ) +
                                                                                  "\n                                "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      _vm._l(
                                                                        val.schedule,
                                                                        function (
                                                                          item,
                                                                          i
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              key:
                                                                                "item-" +
                                                                                i,
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      type: "radio",
                                                                                      disabled:
                                                                                        "",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.schedule_due_date
                                                                                  ) +
                                                                                  "\n                                    \n                                  " +
                                                                                  _vm._s(
                                                                                    item.dosage ||
                                                                                      _vm.$t(
                                                                                        "NA"
                                                                                      )
                                                                                  ) +
                                                                                  "\n                                    \n                                  " +
                                                                                  _vm._s(
                                                                                    item.schedulecompleteddate ||
                                                                                      _vm.$t(
                                                                                        "NA"
                                                                                      )
                                                                                  ) +
                                                                                  "\n                                "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                    ],
                                                                    2
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                        _vm.prescriptionFooterNote1 &&
                                        _vm.prescriptionFooterNote1
                                          .ehr_note_value
                                          ? _c("div", {
                                              staticClass:
                                                "prescriptionFooterNotehold",
                                              attrs: {
                                                id: "prescriptionFooterNote1",
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.prescriptionFooterNote1
                                                    .ehr_note_value
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                        _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              "border-bottom":
                                                "1px solid #d4d5d7",
                                            },
                                            attrs: {
                                              width: "100%",
                                              border: "0",
                                              cellspacing: "0",
                                              cellpadding: "0",
                                              align: "center",
                                            },
                                          },
                                          [
                                            _vm.Doctordetailsshow == true
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticStyle: {
                                                        padding:
                                                          "30px 0 15px 0",
                                                        margin: "0",
                                                      },
                                                      attrs: {
                                                        align: "right",
                                                        valign: "top",
                                                        bgcolor: "#FFFFFF",
                                                      },
                                                    },
                                                    [
                                                      _vm.fileUrl != ""
                                                        ? _c("img", {
                                                            attrs: {
                                                              src: _vm.fileUrl,
                                                              height: "120px",
                                                              width: "Auto",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm.prescriptionobj &&
                                                      _vm.prescriptionobj
                                                        .staffDetails &&
                                                      _vm.tenantId !=
                                                        "05c7079f-d889-4a40-8fac-0ae75c445c15"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                width: "100%",
                                                                "text-align":
                                                                  "right",
                                                                display:
                                                                  "block",
                                                                padding:
                                                                  "10px 0",
                                                              },
                                                              attrs: {
                                                                span: "",
                                                                id: "label_sign_doctorname",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .staffDetails
                                                                      .title
                                                                  ) +
                                                                  "\n                                " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .staffDetails
                                                                      .first_name
                                                                  ) +
                                                                  "\n                                " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .prescriptionobj
                                                                      .staffDetails
                                                                      .last_name
                                                                  ) +
                                                                  "\n                              "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.tenantId ==
                                                      "05c7079f-d889-4a40-8fac-0ae75c445c15"
                                                        ? _c(
                                                            "table",
                                                            {
                                                              attrs: {
                                                                width: "100%",
                                                              },
                                                            },
                                                            [_vm._m(9)]
                                                          )
                                                        : _vm._e(),
                                                      _vm.prescriptionobj
                                                        .footernote1
                                                        ? _c(
                                                            "table",
                                                            {
                                                              attrs: {
                                                                width: "100%",
                                                                cellpadding:
                                                                  "0",
                                                                cellspacing:
                                                                  "0",
                                                              },
                                                            },
                                                            [
                                                              _c("tr", [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    attrs: {
                                                                      align:
                                                                        "center",
                                                                      valign:
                                                                        "top",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("p", {
                                                                      staticStyle:
                                                                        {
                                                                          margin:
                                                                            "10px 0 0",
                                                                          "font-size":
                                                                            "12px",
                                                                        },
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              _vm
                                                                                .prescriptionobj
                                                                                .footernote1
                                                                            ),
                                                                        },
                                                                    }),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c("tfoot", [
                                  _c("tr", [
                                    _c("td", [
                                      _c("div", {
                                        class: _vm.printable_header
                                          ? "page-footer-space"
                                          : "page-footer-nospace",
                                      }),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                class: _vm.printable_header
                                  ? "page-footer"
                                  : "no-footer",
                              },
                              [
                                _vm.printable_header
                                  ? _c("table", { attrs: { width: "100%" } }, [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticStyle: { padding: "10px 0" },
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "body-text",
                                                staticStyle: {
                                                  color: "#212529",
                                                  "font-size": "13px",
                                                  "font-weight": "500",
                                                  "font-style": "normal",
                                                },
                                                attrs: {
                                                  id: "label_footer_disclaimer",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Thisdocumentisdigitallysignedandhencenomanualsignatureisrequired"
                                                      )
                                                    ) +
                                                    "\n                        \n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "13px",
                                                  color: "#aaa",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Poweredby")) +
                                                    "  "
                                                ),
                                              ]
                                            ),
                                            _vm._m(10),
                                            _c("br"),
                                            _vm._m(11),
                                          ]
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm.showhideemailpopup
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  id: "Sendemailp",
                  tabindex: "-1",
                  role: "dialog",
                  "aria-labelledby": "exampleModalCenterTitle",
                  "aria-hidden": "true",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog grt-md",
                    staticStyle: {
                      width: "570px",
                      background: "#fff",
                      "border-radius": "3px",
                      "-webkit-border-radius": "3px",
                    },
                    attrs: { role: "document" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "modal-content",
                        staticStyle: { padding: "20px 50px" },
                      },
                      [
                        _c("div", { staticClass: "modal-header" }, [
                          _c("h5", { staticStyle: { margin: "0px auto" } }, [
                            _vm._v(_vm._s(_vm.$t("SendEmail"))),
                          ]),
                          _vm._m(12),
                        ]),
                        _c("div", { staticClass: "modal-body" }, [
                          _c(
                            "ul",
                            {
                              staticClass: "list-select",
                              staticStyle: { "margin-bottom": "0px" },
                            },
                            [
                              _vm._l(_vm.emaillist, function (item) {
                                return _c(
                                  "li",
                                  { key: item, staticClass: "data-hold" },
                                  [
                                    _c("span", [_vm._v(_vm._s(item))]),
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.removeEmail(item)
                                          },
                                        },
                                      },
                                      [_vm._v("X")]
                                    ),
                                  ]
                                )
                              }),
                              _c("li", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customemail,
                                      expression: "customemail",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder:
                                      "Type in email address & press enter",
                                  },
                                  domProps: { value: _vm.customemail },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.addemail(_vm.customemail)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.customemail = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ],
                            2
                          ),
                          _vm.errorsemail
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "rgba(243, 69, 58, 0.8)",
                                    "font-size": "13px",
                                    "font-weight": "500",
                                    display: "block !important",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.errorsemail))]
                              )
                            : _vm._e(),
                        ]),
                        _vm.emaillist && _vm.emaillist.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "modal-footer",
                                staticStyle: { "padding-top": "0px" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "primary-btn ripple pull-right",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal",
                                      "aria-label": "Close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.senddetailsoveremail()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Send")))]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "close-sec-hold" }, [
      _c(
        "button",
        {
          staticClass: "close pl-2",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "18px",
          background: "#2959a7",
          color: "#ffffff",
          "font-weight": "600",
          padding: "7px 10px",
          "font-size": "15px",
        },
      },
      [
        _c("span", { attrs: { id: "label_symptoms_summary" } }, [
          _vm._v("Vitals"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "18px",
          background: "#2959a7",
          color: "#ffffff",
          "font-weight": "600",
          padding: "7px 10px",
          "font-size": "15px",
        },
      },
      [
        _c("span", { attrs: { id: "label_symptoms_summary" } }, [
          _vm._v("Symptoms & summary"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticStyle: { padding: "0 4px 6px", "vertical-align": "top" } },
      [_c("strong", { attrs: { id: "label_symptoms" } }, [_vm._v("Symptoms:")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticStyle: { padding: "0 4px 6px", "vertical-align": "top" } },
      [_c("strong", { attrs: { id: "label_summary" } }, [_vm._v("Summary:")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "16px",
          background: "#2959a7",
          color: "#ffffff",
          "font-weight": "600",
          padding: "7px 10px",
          "font-size": "15px",
        },
      },
      [_c("span", { attrs: { id: "label_icd10" } }, [_vm._v("ICD10")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "16px",
          background: "#2959a7",
          color: "#ffffff",
          "font-weight": "600",
          padding: "7px 10px",
          "font-size": "15px",
        },
      },
      [
        _c("span", { attrs: { id: "label_prescription_header" } }, [
          _vm._v("Prescription"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "16px",
          background: "#2959a7",
          color: "#ffffff",
          "font-weight": "600",
          padding: "7px 10px",
          "font-size": "15px",
        },
      },
      [
        _c("span", { attrs: { id: "label_investigations_header" } }, [
          _vm._v("Investigations ordered"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "16px",
          background: "#2959a7",
          color: "#ffffff",
          "font-weight": "600",
          padding: "7px 10px",
          "font-size": "15px",
        },
      },
      [
        _c("span", { attrs: { id: "label_immunization_header" } }, [
          _vm._v("Immunization"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { align: "right" } }, [
        _c(
          "p",
          { staticStyle: { "margin-bottom": "5px", "font-weight": "500" } },
          [_vm._v("Dr. Swati Rajagopal, KMC #:61458")]
        ),
        _c("p", {
          staticStyle: { "margin-bottom": "5px", "font-weight": "500" },
        }),
        _c(
          "p",
          { staticStyle: { "margin-bottom": "5px", "font-weight": "500" } },
          [_vm._v("Arista Health Clinic")]
        ),
        _c(
          "p",
          { staticStyle: { "margin-bottom": "5px", "font-weight": "500" } },
          [_vm._v("Aster CMI Hospital")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { "text-decoration": "none" },
        attrs: { href: "https://www.genamet.com/", target: "_blank" },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "13px",
              color: "rgb(0, 86, 224)",
              "text-decoration": "none",
            },
          },
          [_vm._v(" www.genamet.com")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticStyle: { "margin-right": "10px" }, attrs: { href: "#" } },
      [
        _c("img", {
          staticStyle: { "padding-top": "10px" },
          attrs: {
            src: "https://s3.amazonaws.com/genamet-static-uploads-dev/9c42767e-1559-426b-8c70-b54299e091dd/images/powered-genamet.png",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        staticStyle: { top: "10px" },
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }